import { useEffect } from 'react';
import dayjs from 'dayjs';
import { apiGet } from '../api';
import { useAuth } from '../context/useAuth';

/**
 * useSessionWatch Hook
 * 
 * Periodically pings the backend to verify session validity.
 * If the session is revoked (e.g., via Single Session Active kick),
 * the apiFetch wrapper in api/index.js will intercept the 401 
 * and dispatch the 'session-revoked' event, triggering the modal.
 */
export function useSessionWatch() {
    const { token, user, lastActivity } = useAuth();

    useEffect(() => {
        if (!token || !user) return;

        const interval = setInterval(async () => {
            // Heartbeat only if active within the last 2 minutes
            const twoMinutesAgo = dayjs().valueOf() - (2 * 60 * 1000);
            if (lastActivity < twoMinutesAgo) {
                console.debug('[SessionWatch] User inactive, skipping heartbeat check.');
                return;
            }

            try {
                // Ping /users/me to verify session
                await apiGet('/users/me', token);
            } catch (err) {
                // Errors are handled by the apiFetch interceptor in src/api/index.js
                console.debug('[SessionWatch] Heartbeat check failed:', err);
            }
        }, 60000); // Ping every 60 seconds

        return () => clearInterval(interval);
    }, [token, user, lastActivity]);
}
